import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import DangerousHTML from 'Components/Utility/DangerousHTML';
import PrimaryMessage from 'Components/Carousel/PrimaryMessage';
import SecondaryMessage from 'Components/Carousel/SecondaryMessage';
import LinkTag from 'Components/Carousel/LinkTag';


export default function DefaultPanel({ slide, slideUrl, slideExternalLink }) {
  const showMessageBlock = (slide.primary_message && slide.primary_message_type !== 'none')
  || (slide.secondary_message && slide.secondary_message_type !== 'none');

  return (
    <div className="ProductPanel CarouselPanel">
      <div className="CarouselPanel__topContainer">
        <h2 className="CarouselPanel__title CarouselPanel__section">
          <LinkTag
            url={slideUrl}
            externalLink={slideExternalLink}
            className="faux-block-link__overlay-link"
          >
            {slide.name}
          </LinkTag>
        </h2>

        {slide.copy_message &&
          <div className="d-none d-lg-block">
            <DangerousHTML
              html={slide.copy_message}
            />
          </div>
        }

        {showMessageBlock && !slide.copy_message &&
          <div className="CarouselPanel__messageBlock CarouselPanel__section">
            <PrimaryMessage
              customMessage={slide.primary_message}
              messageType={slide.primary_message_type}
              messageData={slide.promotional_message_data}
            />
            <SecondaryMessage
              customMessage={slide.secondary_message}
              messageType={slide.secondary_message_type}
              messageData={slide.promotional_message_data}
            />
          </div>
        }
      </div>
      <div className="CarouselPanel__bottomContainer">
        <div
          className="CarouselPanel__button CarouselPanel__button--primary w-100"
        >
          <FormattedMessage id="categorysalepanel.findoutmore" defaultMessage="Find out more" />
        </div>
      </div>
    </div>
  );
}

DefaultPanel.propTypes = {
  slideUrl: PropTypes.string,
  slide: PropTypes.shape({}),
  slideExternalLink: PropTypes.bool,
};

DefaultPanel.defaultProps = {
  slide: {},
  slideUrl: '',
  slideExternalLink: false,
};
